import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=724ba347&scoped=true&"
import script from "./StaffDetails.vue?vue&type=script&lang=js&"
export * from "./StaffDetails.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=724ba347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ba347",
  null
  
)

export default component.exports